//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.FBM.js";
import "../CAM/CAM.FBM.FeatureGeometry.js";
let d=[[[0,"FormStandard",1,0],[0,"ThreadRotation",1,0]],[[["source"],"SetThreadDataSource",{},1,0],[[],"GetThreadDataSource",{R_:{source:''}},0,0],[[],"GetFormUserDefined",{R_:{userDefinedForm:''}},0,0],[["userDefinedForm"],"SetFormUserDefined",{},1,0],[["tagFeature"],"UpdateThreadParameters",{},1,0]],[]];
SPLM.CAM.FBM.ThreadFeatureGeometry = class extends SPLM.CAM.FBM.FeatureGeometry{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.FBM.ThreadFeatureGeometry";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.FBM.ThreadFeatureGeometry.ThreadDataSource = Object.freeze({
    "FromModel" : "FromModel", "FromTable" : "FromTable"});

SPLM.CAM.FBM.ThreadFeatureGeometry.Form = Object.freeze({
    "Unified" : "Unified", "Acme" : "Acme", "StubAcme" : "StubAcme", "Buttress" : "Buttress", "Metric" : "Metric", "Trapezoidal" : "Trapezoidal", "Lowernherz" : "Lowernherz", "SparkPlug" : "SparkPlug", "Npt" : "Npt", "HoseCoupling" : "HoseCoupling", "FireHose" : "FireHose", "Unj" : "Unj", "Nps" : "Nps", "Bsp" : "Bsp", "Bstp" : "Bstp", "Helicoil" : "Helicoil", "Ns" : "Ns", "UserDefined" : "UserDefined"});

SPLM.CAM.FBM.ThreadFeatureGeometry.Rotation = Object.freeze({
    "RightHand" : "RightHand", "LeftHand" : "LeftHand"});

export default SPLM;